module.exports = __webpack_public_path__ + "media/splash/launch-1242x2208-73e95612.png";